module.exports = __webpack_public_path__ + "img/bell-alert.00ba2d39.svg";